import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const TYPES = [
  { v: "sector", l: "Secteurs" },
  { v: "market", l: "Marchés / zones" },
  { v: "country", l: "Pays" },
  { v: "intent", l: "Intentions" },
];
const inputCls = "w-full border border-tertiary bg-white px-3 py-2 text-sm outline-none focus:border-champagne focus:ring-1 focus:ring-champagne";

export default function TaxonomiesAdmin() {
  const [type, setType] = useState("sector");
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ slug: "", label_fr: "", label_en: "" });

  const load = () => api.get("/admin/taxonomies", { params: { type } }).then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, [type]);

  const add = async (e) => {
    e.preventDefault();
    if (!form.label_fr || !form.label_en) return toast.error("Libellés FR/EN requis");
    const slug = form.slug || form.label_en.toLowerCase().replace(/\s+/g, "-");
    await api.post("/admin/taxonomies", { type, slug, label_fr: form.label_fr, label_en: form.label_en, order: items.length, active: true });
    setForm({ slug: "", label_fr: "", label_en: "" });
    toast.success("Ajouté"); load();
  };
  const toggle = async (t) => { await api.put(`/admin/taxonomies/${t.id}`, { active: !t.active }); load(); };
  const del = async (id) => { await api.delete(`/admin/taxonomies/${id}`); load(); };

  return (
    <div className="max-w-4xl">
      <h1 className="mb-1 font-serif text-3xl text-anthracite">Taxonomies</h1>
      <p className="mb-8 text-sm text-anthracite/50">Référentiel structuré (secteurs, marchés, pays, intentions) — socle du matching et des filtres.</p>

      <div className="mb-6 flex flex-wrap gap-2">
        {TYPES.map((tp) => (
          <button key={tp.v} onClick={() => setType(tp.v)} data-testid={`tax-tab-${tp.v}`} className={`rounded-full border px-4 py-1.5 text-xs ${type === tp.v ? "border-anthracite bg-anthracite text-ivory" : "border-tertiary bg-white text-anthracite/60"}`}>{tp.l}</button>
        ))}
      </div>

      <form onSubmit={add} data-testid="tax-form" className="mb-8 grid gap-3 border border-tertiary bg-white p-5 sm:grid-cols-4">
        <input placeholder="Libellé FR" value={form.label_fr} onChange={(e) => setForm((f) => ({ ...f, label_fr: e.target.value }))} className={inputCls} data-testid="tax-fr" />
        <input placeholder="Libellé EN" value={form.label_en} onChange={(e) => setForm((f) => ({ ...f, label_en: e.target.value }))} className={inputCls} data-testid="tax-en" />
        <input placeholder="Slug (optionnel)" value={form.slug} onChange={(e) => setForm((f) => ({ ...f, slug: e.target.value }))} className={inputCls} />
        <button type="submit" data-testid="tax-add" className="inline-flex items-center justify-center gap-2 bg-anthracite px-4 py-2 text-sm font-medium text-ivory hover:bg-black"><Plus className="h-4 w-4" /> Ajouter</button>
      </form>

      <div className="border border-tertiary bg-white">
        {items.length === 0 ? <p className="py-12 text-center text-sm text-anthracite/40">Aucune entrée.</p> : items.map((t) => (
          <div key={t.id} className="flex items-center gap-4 border-b border-tertiary px-5 py-3 last:border-0">
            <div className="flex-1"><p className="text-sm text-anthracite">{t.label_fr}</p><p className="text-xs text-anthracite/50">{t.label_en} · {t.slug}</p></div>
            <button onClick={() => toggle(t)} className={`rounded-full border px-2.5 py-0.5 text-xs ${t.active ? "border-green-200 bg-green-50 text-green-700" : "border-tertiary bg-sand text-anthracite/50"}`}>{t.active ? "Actif" : "Inactif"}</button>
            <button onClick={() => del(t.id)} className="rounded p-1.5 text-anthracite/50 hover:text-red-600"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
